import { LegalLayout, Lang, Sec, P, Bullets, Divider, CONTACT_EMAIL, SITE_URL } from '@/components/LegalLayout';

export default function Terms() {
  return (
    <LegalLayout
      title="Regulamin / Terms of Service"
      subtitle="Life Leverage OS — Pewnosc Siebie AI"
      updated="Ostatnia aktualizacja / Last updated: czerwiec 2026 / June 2026"
    >
      <Lang code="PL" label="Polski">
        <Sec title="Akceptacja warunków">
          <P>
            Korzystając z Life Leverage OS akceptujesz niniejszy Regulamin. Jeśli nie zgadzasz się
            z warunkami, prosimy nie korzystać z aplikacji.
          </P>
        </Sec>
        <Sec title="Opis usługi">
          <P>
            Aplikacja to osobiste centrum dowodzenia do zarządzania celami, zadaniami, projektami,
            nawykami i finansami, dostarczane przez Pewnosc Siebie AI.
          </P>
        </Sec>
        <Sec title="Twoje konto">
          <P>
            Jesteś odpowiedzialny za zachowanie poufności danych logowania oraz za aktywność na
            swoim koncie. Powiadom nas niezwłocznie o nieautoryzowanym dostępie.
          </P>
        </Sec>
        <Sec title="Twoje treści">
          <P>
            Zachowujesz prawo własności do treści, które wprowadzasz (cele, zadania, projekty,
            nawyki, wpisy finansowe). Udzielasz nam jedynie ograniczonej licencji niezbędnej do
            działania, przechowywania i synchronizacji aplikacji na Twoją rzecz.
          </P>
        </Sec>
        <Sec title="Dozwolone korzystanie">
          <Bullets
            items={[
              'nie korzystaj z aplikacji w sposób niezgodny z prawem,',
              'nie naruszaj praw innych osób ani bezpieczeństwa usługi,',
              'nie podejmuj prób zakłócania działania lub uzyskania nieautoryzowanego dostępu.',
            ]}
          />
        </Sec>
        <Sec title="Funkcje AI">
          <P>
            Aplikacja udostępnia funkcje AI o charakterze pomocniczym. Sugestie AI mają charakter
            informacyjny i nie stanowią porady finansowej, prawnej ani medycznej.
          </P>
        </Sec>
        <Sec title="Wyłączenie odpowiedzialności">
          <P>
            Aplikacja jest udostępniana „taka, jaka jest”, bez gwarancji. W maksymalnym zakresie
            dozwolonym przez prawo nie ponosimy odpowiedzialności za szkody wynikające z
            korzystania lub niemożności korzystania z aplikacji.
          </P>
        </Sec>
        <Sec title="Zakończenie korzystania">
          <P>
            Możesz w dowolnym momencie zakończyć korzystanie i usunąć konto (zob. „Usuwanie
            konta”). Możemy zawiesić lub ograniczyć dostęp w przypadku naruszenia Regulaminu.
          </P>
        </Sec>
        <Sec title="Zmiany">
          <P>
            Możemy aktualizować niniejszy Regulamin. Dalsze korzystanie z aplikacji po zmianach
            oznacza ich akceptację.
          </P>
        </Sec>
        <Sec title="Kontakt">
          <P>
            Pewnosc Siebie AI · {CONTACT_EMAIL} · {SITE_URL}
          </P>
        </Sec>
      </Lang>

      <Divider />

      <Lang code="EN" label="English">
        <Sec title="Acceptance of terms">
          <P>
            By using Life Leverage OS you accept these Terms of Service. If you do not agree with
            them, please do not use the App.
          </P>
        </Sec>
        <Sec title="Service description">
          <P>
            The App is a personal command center for managing goals, tasks, projects, habits and
            finances, provided by Pewnosc Siebie AI.
          </P>
        </Sec>
        <Sec title="Your account">
          <P>
            You are responsible for keeping your login credentials confidential and for the
            activity on your account. Notify us promptly of any unauthorized access.
          </P>
        </Sec>
        <Sec title="Your content">
          <P>
            You retain ownership of the content you enter (goals, tasks, projects, habits, finance
            entries). You grant us only the limited license necessary to operate, store and
            synchronize the App on your behalf.
          </P>
        </Sec>
        <Sec title="Acceptable use">
          <Bullets
            items={[
              'do not use the App for any unlawful purpose,',
              'do not infringe the rights of others or the security of the service,',
              'do not attempt to disrupt the App or gain unauthorized access.',
            ]}
          />
        </Sec>
        <Sec title="AI features">
          <P>
            The App provides assistive AI features. AI suggestions are informational only and do
            not constitute financial, legal or medical advice.
          </P>
        </Sec>
        <Sec title="Disclaimer">
          <P>
            The App is provided “as is”, without warranties. To the maximum extent permitted by
            law, we are not liable for damages arising from your use of, or inability to use, the
            App.
          </P>
        </Sec>
        <Sec title="Termination">
          <P>
            You may stop using the App and delete your account at any time (see “Delete account”).
            We may suspend or limit access in case of a breach of these Terms.
          </P>
        </Sec>
        <Sec title="Changes">
          <P>
            We may update these Terms. Continued use of the App after changes constitutes
            acceptance of the updated Terms.
          </P>
        </Sec>
        <Sec title="Contact">
          <P>
            Pewnosc Siebie AI · {CONTACT_EMAIL} · {SITE_URL}
          </P>
        </Sec>
      </Lang>
    </LegalLayout>
  );
}
